<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="작업계획서 일정 관리 상세" device="web" :headerTitleTooltip="headerTitleTooltip">
        <template v-slot:body>
          <v-row no-gutters class="margin-top:-10px; d-flex justify-space-between">
            <span class="d-flex align-center" style="gap: 12px">
              <h5>
                <b>{{ currentYear }}년 {{ currentMonth }}</b
                >월 작업계획일 ( 등록 작업일: <b>{{ workPlanSummaryData.registWorkDaysCnt }}</b
                >일 / 작업계획건수: <b>{{ workPlanSummaryData.registWorkPlanCnt }}</b
                >건 / 미등록 작업계획일수: <b>{{ workPlanSummaryData.unregisteredWorkPlanCnt }}</b
                >일 )
              </h5>
            </span>
          </v-row>
          <v-row no-gutters>
            <h5>
              <b>{{ currentYear }}년</b> 전체 작업계획일 ( 등록 작업일: <b>{{ workPlanSummaryData.totalRegistWorkDaysCnt }}</b
              >일)
            </h5>
          </v-row>
          <v-layout column>
            <v-col cols="12" md="12" class="row pa-0">
              <v-col cols="12" class="pa-0">
                <v-sheet class="d-flex justify-space-between align-center">
                  <v-sheet class="d-flex justify-space-between align-center">
                    <v-btn outlined color="btn_outline" class="outlined-btn" large width="92" @click="setToday">
                      <div class="d-flex align-center" style="gap: 8px">
                        <svg-icon icon-class="history" class="btn_text--text" />
                        <span style="font-size: 1rem" class="main_text--text">금일</span>
                      </div>
                    </v-btn>
                    <v-btn icon class="ma-2" @click="prevMonth()">
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="$refs.calendar">
                      {{ $refs.calendar.title ? $refs.calendar.title.replace(/^(\d+)\s*월\s*(\d+)$/g, '$2년 $1월') : '' }}
                    </v-toolbar-title>
                    <v-btn icon class="ma-2" @click="nextMonth()">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-sheet>
                  <v-sheet class="d-flex align-center" style="gap: 12px">
                    <div class="d-flex align-center">
                      <div style="width: 20px; height: 20px; border-radius: 20%" :style="{ backgroundColor: colors[0] }"></div>
                      <span class="mx-1"> 템플릿 작업계획서 </span>
                      <v-tooltip top color="primary" max-width="500px">
                        <template v-slot:activator="{ on }">
                          <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                        </template>
                        <div class="tooltip-text">소중안에서 제공하는 템플릿으로 작성한 문서</div>
                      </v-tooltip>
                    </div>
                    <div class="d-flex align-center">
                      <div style="width: 20px; height: 20px; border-radius: 20%" :style="{ backgroundColor: colors[1] }"></div>
                      <span class="mx-1"> 파일 작업계획서 </span>
                      <v-tooltip top color="primary" max-width="500px">
                        <template v-slot:activator="{ on }">
                          <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                        </template>
                        <div class="tooltip-text">업로드한 수기작성 문서</div>
                      </v-tooltip>
                    </div>
                  </v-sheet>
                </v-sheet>

                <v-sheet height="550">
                  <v-calendar
                    ref="calendar"
                    v-model="value"
                    :weekdays="weekday"
                    type="month"
                    :event-overlap-threshold="30"
                    :events="events"
                    @click:date="toggleDate"
                    @click:event="onEventClick($event)"
                  >
                    <template #day-label="{ date }">
                      <div class="day-label-cell" @click="toggleDate({ date })">
                        <div class="day-label-cell__overlay">
                          <svg-icon icon-class="card_add" class style="height: 1.65rem !important" />
                        </div>
                        <div v-if="date === today" class="v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--small transparent">
                          <span class="date-btn-today">{{ new Date(date).getDate() }}</span>
                        </div>
                        <div v-else class="v-btn v-btn--fab v-btn--has-bg v-btn--round theme--light v-size--small transparent">
                          <span v-if="new Date(date).getMonth() + 1 !== parseInt(currentMonth) && new Date(date).getDate() === 1" class="date-btn">{{
                            `${new Date(date).getMonth() + 1}월 ${new Date(date).getDate()}일`
                          }}</span>
                          <span v-else class="date-btn">{{ new Date(date).getDate() }}</span>
                        </div>
                      </div>
                    </template>
                  </v-calendar>
                </v-sheet>
              </v-col>
            </v-col>
          </v-layout>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right headerTitle :useBtnList="buttonUseList" @btnSearch="btnSearch(true)" @btnDelete="btnDelete()" @btnPrint="btnPrint">
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'목록으로'"
              height="92px"
              :icon="'back'"
              @click="btnCancel()"
              :appendDivider="true"
            ></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
    <i-dxpopup
      :popupVisible="popupVisible"
      :title="methodPopupTitle"
      @popupCloseButtonClick="popupClose"
      :height="popupHeight + 'px'"
      width="500px"
      :max-height="popupHeight + 'px'"
      max-width="500px"
    >
      <template v-if="!fileMode" v-slot:content>
        <v-row no-gutters class="template-btn-wrap">
          <v-col cols="12" md="6">
            <v-card @click="btnMethod('template')" class="template-btn">
              <svg-icon icon-class="template" style="height: 60px" />
              <div class="btn-title">
                템플릿 활용
                <v-tooltip top color="primary" max-width="240px">
                  <template v-slot:activator="{ on }">
                    <svg-icon icon-class="info" style="height: 1rem" v-on="on" />
                  </template>
                  <div class="tooltip-text">소중안에서 제공하는 템플릿을 사용하여 생성합니다.</div>
                </v-tooltip>
              </div>
              <div class="btn-desc">소중안에서 제공해드리는 자료로 작업계획서를 생성합니다.</div>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card @click="btnMethod('file')" class="template-btn">
              <svg-icon icon-class="template" style="height: 60px" />
              <div class="btn-title">기존 파일 업로드</div>
              <div class="btn-desc">
                소중안의 시스템을 활용하는 대신,
                <br />기존 작업계획서 파일을 업로드합니다.
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template v-if="fileMode" v-slot:grid>
        <div class="v-application" style="display: block !important; position: relative; height: 100%">
          <v-card style="padding-bottom: 80px">
            <v-row>
              <v-col cols="6">
                <div class="editor-label required d-flex align-center">
                  <span>작업 시작일</span>
                </div>
                <v-text-field
                  class="editor_bg"
                  :value="formatDate(workDtS)"
                  solo
                  hide-details="auto"
                  :rules="[rules.required, rules.dateFormat]"
                  :placeholder="'ex)2026.01.01'"
                  :mask="'####.##.##'"
                  @change="updateEditingData('workDtS', $event)"
                />
              </v-col>
              <v-col cols="6">
                <div class="editor-label required d-flex align-center">
                  <span>작업 종료일</span>
                </div>
                <v-text-field
                  class="editor_bg"
                  :value="formatDate(workDtE)"
                  solo
                  hide-details="auto"
                  :rules="[rules.required, rules.dateFormat]"
                  :placeholder="'ex)2026.01.01'"
                  :mask="'####.##.##'"
                  @change="updateEditingData('workDtE', $event)"
                />
              </v-col>
            </v-row>
            <v-row style="padding: 0 16px">
              <iFileManage
                ref="iFileUploader"
                :targetId="targetId"
                targetType="00024"
                @onFileChanged="onFileChanged"
                :fileExtension="allowedFileExtensions.join(',')"
              />
            </v-row>
          </v-card>
        </div>
      </template>
      <template v-if="fileMode" v-slot:footer>
        <div class="v-application">
          <v-row class="d-flex justify-end" style="gap: 12px">
            <!-- <v-btn elevation="0" large color="error" class="float-right rounded mt-1" @click="btnPopupDelete">삭제</v-btn> -->
            <v-btn elevation="0" large color="primary" class="float-right rounded mt-1" @click="btnPopupSave">저장</v-btn>
            <v-btn elevation="0" large color="desc_text" class="float-right rounded mt-1" @click="popupClose">닫기</v-btn>
          </v-row>
        </div>
      </template>
    </i-dxpopup>
  </v-container>
</template>
<script>
// components
import iCardRight from '@/components/common/iCardRight.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import iDxPopup from '@/components/common/iDxPopup.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import { getCurrentDate, getDateDiff } from '@/utils/common'
import {
  getSafetyWorkPlanManageDetail,
  cancelSelectedWorkPlan,
  deleteSafetyWorkPlanManageFormDetail,
  applySelectedWorkPlan,
  saveSafetyWorkPlanManageFormFile,
  getSafetyWorkPlanManageReport,
} from '@/api/riskAssessment/safetyWorkPlanManage.js'
import { downloadAttachedFileZip } from '@/api/baseManage/fileUpload'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'safetyWorkPlanManageDetail',
  components: {
    'i-card-vertical': iCardVertical,
    'i-dxpopup': iDxPopup,
    iCardRight,
    iFileManage,
    // 절차서 컴포넌트
    // ProcedureComponent
  },
  data() {
    return {
      buttonUseList: [
        'btnSearch', //조회
        'btnDelete', // 삭제
        'btnPrint', // 출력
      ],
      gridMain: [],
      valid: true,
      methodPopupTitle: '',
      headerTitleTooltip: '날짜를 클릭하여 신규로 추가하거나, 기존 작업계획서를 선택하여 수정할 수 있습니다.',
      allMode: 'allPages',
      initCompId: '',
      mainData: {},
      today: getCurrentDate(),
      popupVisible: false,
      workPlanSummaryData: {
        registWorkDaysCnt: 0, // 해당 년도, 월 등록 작업일
        registWorkPlanCnt: 0, // 해당 년도, 월 작업계획건수
        unregisteredWorkPlanCnt: 0, // 해당 년도, 월 미등록 작업계획건수
        totalRegistWorkDaysCnt: 0, // 해당 년도 전체 등록 작ㄷ업일
      },
      numberMatch: /^\d+$/,
      rules: {
        number: (value) => {
          if (this.numberMatch.test(value)) {
            return true
          }
          return '양수만 입력해주세요.'
        },
        required: (value) => !!value || '필수',
        dateFormat: (value) => {
          if (!value || /^\d{4}\.\d{2}\.\d{2}$/.test(value)) {
            return true
          }
          return 'YYYY.MM.DD'
        },
      },
      // 캘린더 관련
      focus: '',
      weekday: [0, 1, 2, 3, 4, 5, 6],
      events: [],
      value: '',
      names: ['작업계획', '파일'],
      colors: ['#4599EE', '#61AC5A', 'red'],
      currentYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
      totalRegistWorkDaysCnt: 0, // 등록 작업일(전체)
      workPlanData: [],
      selectedDatePlanData: {
        clntId: '',
        compId: '',
        writeDt: '',
      },
      dateClickFlag: false,
      // 파일 관련
      fileList: {
        insert: [],
        delete: [],
      },
      editable: false,
      popupHeight: 336,
      routerParam: {},
      fileMode: false,
      targetId: '',
      workDtS: '',
      workDtE: '',
      allowedFileExtensions: ['.jpg', '.jpeg', '.png', '.pdf'],
    }
  },
  computed: {
    mobileTrigger: function () {
      return this.getWidth() < 1920
    },
    isEditable: function () {
      // 권한에 따른 수정 가능 여부
      let editable = false
      if (this.$store.state.menu.myAuthGrps) {
        // 로그인 시 호출하는 권한 정보를 state에 저장하고, 이 저장된 정보를 불러와 버튼 권한을 부여한다. 2024.07.18 LJH
        let authGrps = this.$store.state.menu.myAuthGrps.find((x) => x.progCd == this.$route.meta.proc_cd)
        if (authGrps.savAh === 'Y') {
          editable = true
        }
      }
      return editable
    },
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
    this.mainData = this.$route.params.data
    if (!this.mainData) {
      this.mainData = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        month: new Date().getMonth() + 1,
        writeYear: new Date().getFullYear(),
      }
    }
    this.currentYear = this.mainData.writeYear
    this.value = `${this.currentYear}-${this.currentMonth}-01`
    this.btnSearch(true)
  },
  async activated() {
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
    }
    this.mainData = this.$route.params.data
    if (!this.mainData) {
      this.mainData = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        month: new Date().getMonth() + 1,
        writeYear: new Date().getFullYear(),
      }
    }
    this.currentYear = this.mainData.writeYear
    this.value = `${this.currentYear}-${this.currentMonth}-01`
    this.btnSearch(true)
  },
  beforeDestroy() {
    this.$EventBus.$off('searchWorkPlan')
  },
  methods: {
    ///////////////////////////////////////
    /*       Toolbar Button Event        */
    ///////////////////////////////////////
    //------------------------------------------
    //  목록
    //------------------------------------------
    btnCancel() {
      const toRouter = {
        name: 'SafetyWorkPlanManage',
        params: {
          search: true,
        },
      }
      this.$router.push(toRouter)
    },
    //------------------------------------------
    //  조회
    //------------------------------------------
    async btnSearch(notify = true) {
      this.mainData.writeYear = this.currentYear.toString()
      this.mainData.month = this.currentMonth.toString().padStart(2, '0')
      this.openLoading()
      await getSafetyWorkPlanManageDetail(this.mainData, notify)
        .then((res) => {
          this.workPlanSummaryData.registWorkDaysCnt = res.registWorkDaysCnt
          this.workPlanSummaryData.registWorkPlanCnt = res.registWorkPlanCnt
          this.workPlanSummaryData.unregisteredWorkPlanCnt = res.unregisteredWorkPlanCnt
          this.workPlanSummaryData.totalRegistWorkDaysCnt = res.totalRegistWorkDaysCnt
          this.workPlanData = res.resultList
          const start = {
            date: `${this.mainData.writeYear}-${this.mainData.month}-01`,
          }
          this.getEvents({ start })
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    //------------------------------------------
    //  삭제
    //------------------------------------------
    btnDelete() {
      const msg = `작성된 ${this.currentYear}년 ${this.currentMonth}월 전체 작업계획서가 삭제됩니다.<br/>그래도 계속하시겠습니까?`
      this.vToastifyPrompt(msg, 'info', async (current) => {
        this.openLoading()
        await deleteSafetyWorkPlanManageFormDetail(this.workPlanData, true)
          .then((res) => {
            if (res.success) {
              this.btnSearch(false)
            }
          })
          .catch((err) => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
    //------------------------------------------
    //  출력
    //------------------------------------------
    btnPrint(type) {
      console.log('this.workPlanData', this.workPlanData)
      const param = {
        clntId: this.mainData.clntId,
        compId: this.mainData.compId,
        writeYear: this.currentYear,
        month: this.currentMonth.toString(),
        type: type,
      }
      this.openLoading()
      getSafetyWorkPlanManageReport(param, false)
        .then((res) => {
          console.log('#res', res)
          this.endLoading()
          this.downloadReport(res, `${this.currentYear}년 ${this.currentMonth}월 작업계획서.${type}`)
        })
        .catch(() => {
          this.endLoading()
        })
    },
    ///////////////////////////////////////
    /*       Function Button Event        */
    ///////////////////////////////////////
    // '금일' 버튼 클릭 시
    setToday() {
      this.focus = ''
      this.value = new Date()
      this.currentYear = new Date().getFullYear()
      this.currentMonth = new Date().getMonth() + 1
      this.btnSearch(true)
    },
    // 캘린더의 이전 월 이동 시
    async prevMonth() {
      await this.$refs.calendar.prev()
      this.monthChanged()
    },
    // 캘린더의 다음 월 이동 시
    async nextMonth() {
      await this.$refs.calendar.next()
      this.monthChanged()
    },
    // 캘린더의 월 변경 시
    monthChanged() {
      this.$nextTick(() => {
        if (this.$refs.calendar && this.$refs.calendar.title) {
          const match = this.$refs.calendar.title.match(/^(\d+)\s*월\s*(\d+)$/)
          if (match) {
            const year = parseInt(match[2])
            const month = parseInt(match[1])
            this.currentYear = year
            this.currentMonth = month.toString().padStart(2, '0')
            setTimeout(() => {
              this.btnSearch(true)
            }, 100)
          }
        }
      })
    },
    // 캘린더의 날짜 이벤트 생성(작업계획, 파일)
    addWorkFileEvents(evts, baseDate) {
      const year = baseDate.getFullYear()
      const month = (baseDate.getMonth() + 1).toString().padStart(2, '0')
      const day = baseDate.getDate().toString().padStart(2, '0')
      const dateString = `${year}${month}${day}`
      // workPlanData에 해당 날짜 데이터만 추출하여 바인딩
      if (this.workPlanData && Array.isArray(this.workPlanData)) {
        const todayData = this.workPlanData.filter((item) => item.writeDt === dateString)
        // 해당 날짜에 데이터가 있을 경우
        todayData.forEach((item, idx) => {
          // 작업계획 처리
          let eventName = `${item.workPlanTitle}`
          let colorIdx = item.fileOnly === 'Y' ? 1 : 0
          const startTime = new Date(`${item.workDtS.substr(0, 4)}-${item.workDtS.substr(4, 2)}-${item.workDtS.substr(6, 2)}T00:00:00`)
          const endTime = new Date(`${item.workDtE.substr(0, 4)}-${item.workDtE.substr(4, 2)}-${item.workDtE.substr(6, 2)}T00:00:00`)
          evts.push({
            name: eventName,
            start: startTime,
            end: endTime,
            color: this.colors[colorIdx],
            param: {
              clntId: item.clntId,
              compId: item.compId,
              writeDt: item.writeDt,
              docNo: item.docNo,
            },
          })

          //  // 파일 개수 처리
          //   eventName = `${this.names[1]} (${item.fileCnt ?? 0}개)`
          //   // 파일 처리
          //   colorIdx = 2
          //   if (item.fileCnt > 0) {
          //     colorIdx = 1 // 파일이 있을 경우 색상 인덱스 2번(예시)
          //   } else if (item.fileCnt == 0) {
          //     colorIdx = 2
          //   }
          //   evts.push({
          //     name: eventName,
          //     start: startTime,
          //     end: endTime,
          //     color: this.colors[colorIdx]
          //   })
        })
      }
    },
    // 캘린더의 날짜 이벤트 생성
    getEvents({ start }) {
      const evts = []
      this.addEvents(evts)
      this.events = evts
    },
    addEvents(evts) {
      this.workPlanData.forEach((item) => {
        let eventName = `${item.workPlanTitle}`
        let colorIdx = item.fileOnly === 'Y' ? 1 : 0
        const startTime = new Date(`${item.workDtS.substr(0, 4)}-${item.workDtS.substr(4, 2)}-${item.workDtS.substr(6, 2)}T00:00:00`)
        const endTime = new Date(`${item.workDtE.substr(0, 4)}-${item.workDtE.substr(4, 2)}-${item.workDtE.substr(6, 2)}T00:00:00`)
        evts.push({
          name: eventName,
          start: startTime,
          end: endTime,
          color: this.colors[colorIdx],
          param: {
            clntId: item.clntId,
            compId: item.compId,
            writeDt: item.writeDt,
            docNo: item.docNo,
          },
        })
      })
    },
    updateEditingData(type, value) {
      this[type] = value
    },
    onFileChanged(fileList) {
      this.fileList = fileList
    },
    btnMethod(type) {
      if (type === 'template') {
        this.popupVisible = false
        const routeData = this.$router.resolve({
          name: 'SafetyWorkPlanManageDetailForm',
          query: {
            clntId: AesEncrypt(this.routerParam.clntId),
            compId: AesEncrypt(this.routerParam.compId),
            writeDt: AesEncrypt(this.routerParam.writeDt),
            __created__: true,
          },
        })
        const width = Math.round(window.innerWidth * 0.35)
        const height = Math.round(window.innerHeight * 0.9)
        const left = Math.round((window.screen.width - width) / 2)
        const top = Math.round((window.screen.height - height) / 2)
        const popup = window.open(routeData.href, '_blank', `width=${width},height=${height},left=${left},top=${top},resizable=yes`)

        const timer = setInterval(() => {
          if (!popup || popup.closed) {
            clearInterval(timer)
            this.btnSearch(true)
          }
        }, 500)
      } else if (type === 'file') {
        this.popupVisible = true
        this.fileMode = true
        this.popupHeight = 500
      }
    },
    formatDate(date) {
      if (!date) return null
      if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    // 캘린더의 날짜 클릭 시 (추가)
    toggleDate({ date }) {
      this.popupHeight = 336
      this.fileMode = false
      this.routerParam = {
        clntId: this.mainData.clntId,
        compId: this.mainData.compId,
        writeDt: date.replaceAll('-', ''),
      }
      this.workDtS = date.replaceAll('-', '.')
      this.workDtE = date.replaceAll('-', '.')
      this.methodPopupTitle = `신규 작업계획서 (${this.workDtS})`
      this.popupVisible = true
    },
    // 캘린더의 이벤트(작업계획) 선택 시 (상세)
    async onEventClick(e) {
      this.dateClickFlag = true
      // if (this.dateClickFlag) {
      //   return
      // }
      const routerParam = e.event.param
      // 라우터를 새창(탭)에서 열기
      // 쿼리로 파라미터 전달
      const routeData = this.$router.resolve({
        name: 'SafetyWorkPlanManageDetailForm',
        query: {
          clntId: AesEncrypt(routerParam.clntId),
          compId: AesEncrypt(routerParam.compId),
          writeDt: AesEncrypt(routerParam.writeDt),
          docNo: AesEncrypt(routerParam.docNo),
          __created__: false,
        },
      })
      console.log('routerParam', routerParam)
      const width = Math.round(window.innerWidth * 0.35)
      const height = Math.round(window.innerHeight * 0.9)
      const left = Math.round((window.screen.width - width) / 2)
      const top = Math.round((window.screen.height - height) / 2)
      const popup = window.open(
        routeData.href,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes`
      )
      const timer = setInterval(() => {
        if (!popup || popup.closed) {
          clearInterval(timer)
          this.btnSearch(true)
        }
      }, 500)
    },
    // 팝업 삭제
    btnPopupDelete() {
      this.vToastifyPrompt(
        `${this.currentYear}년 ${this.currentMonth}월 ${this.selectedDatePlanData.writeDt.substring(6, 8)}일 작업 계획을 삭제하시겠습니까?`,
        'info',
        async (current) => {
          await cancelSelectedWorkPlan([this.selectedDatePlanData], true)
            .then((res) => {
              if (res.success) {
                this.popupVisible = false
                this.btnSearch(false)
              }
            })
            .catch((err) => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        }
      )
    },

    // 팝업 저장
    btnPopupSave() {
      const title = `${this.routerParam.writeDt.substring(0, 4)}년 ${this.routerParam.writeDt.substring(4, 6)}월 ${this.routerParam.writeDt.substring(
        6,
        8
      )}일 작업 계획서`
      this.vToastifyPrompt(`${title}를 저장하시겠습니까?`, 'info', async (current) => {
        const diff = getDateDiff(this.workDtS, this.workDtE)
        if (diff.month > 1) {
          this.vSnackbar('작업 기간이 1개월 이상 차이납니다.', 'error')
          return
        }
        const param = {
          clntId: this.routerParam.clntId,
          compId: this.routerParam.compId,
          writeDt: this.routerParam.writeDt,
          workPlanTitle: title,
          workDtS: this.workDtS,
          workDtE: this.workDtE,
          tbmCnt: diff.date + 1,
        }
        await saveSafetyWorkPlanManageFormFile(param, true)
          .then(async (res) => {
            console.log('res', res)
            this.popupVisible = false
            this.fileMode = false
            const targetId = `${this.routerParam.clntId}_${this.routerParam.compId}_${this.routerParam.writeDt}_${res.docNo}`
            console.log('targetId', targetId)
            this.fileList.insert.forEach((file) => {
              file.targetId = targetId
            })
            if (this.$refs.iFileUploader) {
              await this.$refs.iFileUploader.btnSave(this.fileList)
              this.btnSearch(false)
            } else {
              this.btnSearch(false)
            }
          })
          .catch((err) => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },

    // 팝업 닫기
    popupClose() {
      this.popupVisible = false
    },
    // chips스크롤을 오른쪽 끝으로 이동
    scrollToRight() {
      this.$nextTick(() => {
        if (this.$refs.selectedDateContainer) {
          const container = this.$refs.selectedDateContainer
          container.scrollLeft = container.scrollWidth - container.clientWidth
        }
        setTimeout(() => {
          this.dateClickFlag = false
        }, 100)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/theme/variables.scss';

.day-label-cell {
  position: relative;
  cursor: pointer;
  min-height: 100%;

  &__overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.08);
    opacity: 0;
    // transition: opacity 0.2s ease;
    pointer-events: none;
  }

  &__plus {
    font-size: 1.5rem;
    font-weight: 300;
    color: rgba(0, 0, 0, 0.6);
    line-height: 1;
  }

  &:hover .day-label-cell__overlay {
    opacity: 1;
  }

  // 호버 시 일자 숫자 숨김 (오버레이만 보이도록)
  &:hover > div:not(.day-label-cell__overlay) {
    opacity: 0;
    pointer-events: none;
    // transition: opacity 0.2s ease;
  }
  .date-btn-today {
    background-color: #1b53f3 !important;
    color: #ffffff !important;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
  }
  .date-btn {
    height: 20px;
    width: 100%;
    font-size: 12px;
    font-weight: 500;
  }
}

.template-btn-wrap {
  padding: 0 24px;
  gap: 12px;
  flex-wrap: nowrap;
  .col-md-6,
  .col-12 {
    flex: unset !important;
  }
}
.template-btn {
  border-radius: 8px;
  border: 2px solid $card_border;
  background: $white;
  padding: 40px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  word-break: keep-all;

  .btn-title {
    font-size: 1rem;
    font-weight: 600;
    line-height: normal;
    padding: 8px 0 24px;
  }
  .btn-desc {
    color: #808080;
    text-align: center;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: normal;
  }
  &:hover {
    border: 2px solid $primary;
    box-shadow: 0px 4px 8px 0px rgba(27, 83, 243, 0.15);
    .btn-title {
      font-size: 1rem;
      font-weight: 600;
      line-height: normal;
      color: $primary;
    }
  }
}
.tooltip-text {
  word-break: keep-all;
}
.selected-date-container {
  width: 300px;
  min-height: 45px;
  max-height: 45px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  .v-chip {
    flex-shrink: 0;
    white-space: nowrap;
  }
  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
    &:hover {
      background: #555;
    }
  }
}

.text-right ::v-deep input {
  text-align: right !important;
}
.text-right ::v-deep .v-input__control {
  min-width: 0;
}
.text-right ::v-deep .v-text-field {
  flex: 1;
  min-width: 0;
}
</style>
